/* ENTER ON A PHONE (Max 04/11, on his phone in GCC: "ấn nhập thì lại send tin nhắn, tui muốn enter xuống dòng"): on a touch screen
   the keyboard's Enter is the only way to start a new line, and the Send button is right there — so Enter writes a line break and
   only the button sends. With a mouse and keyboard Enter still sends (Shift+Enter a new line), as before. */
export const isTouch = () => {
  try { return window.matchMedia('(pointer: coarse)').matches && !window.matchMedia('(pointer: fine)').matches; } catch (e) { return false; }
};
/** true when this Enter should send the message */
export const enterSends = (e) => e.key === 'Enter' && !e.shiftKey && !(e.nativeEvent && e.nativeEvent.isComposing) && !isTouch();
/** a phone-sized screen, touch or not — for the short hints in the boxes (Max 04/11: the long one still showed on his iPhone) */
export const isSmall = () => {
  try { return isTouch() || window.matchMedia('(max-width: 700px)').matches; } catch (e) { return false; }
};
